export function getFormattedLineItemForTracking(lineItem) {
  return lineItem.map((item) => item.uniquesliid || item.id);
}

/**
 * It creates user industry settings object
 * @param {string} currency - currency
 * @param {string} industryId - industry id
 * @param {array} subIndustryId - subindustry id
 * @param {boolean} showBlankRowsValue - show blank rows value
 * @param {boolean} isIndexToHundreadSelected - index to 100 value selected or not
 * @return {object} user industry setting object which is used to save the selected filters
 */
export function createUserIndustrySettings(
  currency,
  industryId,
  subIndustryId,
  showBlankRowsValue = false,
  isIndexToHundreadSelected = false,
) {
  const result: {
    industry_id;
    subindustry_id;
    currency?;
    show_blank_rows?;
    index_to_100?;
  } = {
    industry_id: industryId,
    subindustry_id: [subIndustryId],
  };
  if (currency) {
    result.currency = currency;
  }
  if (showBlankRowsValue !== undefined && showBlankRowsValue !== null) {
    result.show_blank_rows = showBlankRowsValue;
  }
  if (
    isIndexToHundreadSelected !== undefined &&
    isIndexToHundreadSelected !== null
  ) {
    result.index_to_100 = isIndexToHundreadSelected;
  }

  return result;
}

export function getRatiosIdAndName(ratios) {
  return ratios.ratio_details
    .filter((item) => item.ratio.selected)
    .map((el) => {
      const sliId = el.ratio.usliid || el.ratio.sliid || el.ratio.el.sli_id;
      return {
        name: el.ratio.label,
        uniquesliid: sliId,
      };
    });
}
